import { c as _c } from "react/compiler-runtime";
// «Отзывы» — макет «Профиль»: сегменты «Ждут отзыва | Мои отзывы».
// Ждут — товары доставленных заказов без отзыва (GET /buyer/reviews/pending);
// клик по звезде открывает модалку отзыва (общая leave-review, как у магазина)
// с этой оценкой; фото/видео — POST /buyer/reviews/media, отправка — POST
// /buyer/reviews. Мои — GET /buyer/reviews с медиа и ответом продавца.

import { Skeleton } from "@osmix/ui/skeleton";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useSearchParams } from "react-router";
import { toast } from "sonner";
import { api, type BuyerPendingReview } from "@/api";
import { ProfilePanel, ProfileSegments } from "@/components/profile/profile-shell";
import { CabinetEmpty } from "@/components/profile/return-parts";
import { MyReviewCard, PendingReviewCard } from "@/components/profile/review-cards";
import { LeaveReviewModal, type ReviewMediaItem } from "@/components/shop/leave-review-modal";
import { useProfile } from "@/store";
type Tab = "pending" | "mine";
export function ProfileReviewsPage() {
  const $ = _c(27);
  const userId = useProfile(_temp);
  const qc = useQueryClient();
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") === "mine" ? "mine" : "pending";
  const [rating, setRating] = useState(null);
  let t0;
  if ($[0] !== userId) {
    t0 = {
      queryKey: ["buyer", userId, "reviews", "pending"],
      queryFn: _temp2
    };
    $[0] = userId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const pending = useQuery(t0);
  let t1;
  if ($[2] !== userId) {
    t1 = {
      queryKey: ["buyer", userId, "reviews", "mine"],
      queryFn: _temp3
    };
    $[2] = userId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const mine = useQuery(t1);
  const active = tab === "pending" ? pending : mine;
  let t2;
  if ($[4] !== qc || $[5] !== rating || $[6] !== setParams || $[7] !== userId) {
    t2 = async input => {
      if (!rating) {
        return;
      }
      await api.cabinet.createReview({
        productId: rating.item.productId,
        orderId: rating.item.orderId,
        rating: input.rating,
        text: input.text || undefined,
        anonymous: input.anonymous,
        media: input.media
      });
      toast.success("\u0421\u043F\u0430\u0441\u0438\u0431\u043E! \u041E\u0442\u0437\u044B\u0432 \u043E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D");
      await qc.invalidateQueries({
        queryKey: ["buyer", userId, "reviews"]
      });
      setParams({
        tab: "mine"
      }, {
        replace: true
      });
    };
    $[4] = qc;
    $[5] = rating;
    $[6] = setParams;
    $[7] = userId;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const submit = t2;
  let t3;
  if ($[9] !== setParams) {
    t3 = v => setParams(v === "pending" ? {} : {
      tab: v
    }, {
      replace: true
    });
    $[9] = setParams;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [{
      value: "pending",
      label: "\u0416\u0434\u0443\u0442 \u043E\u0442\u0437\u044B\u0432\u0430"
    }, {
      value: "mine",
      label: "\u041C\u043E\u0438 \u043E\u0442\u0437\u044B\u0432\u044B"
    }];
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== tab) {
    t5 = <ProfileSegments value={tab} onChange={t3} options={t4} />;
    $[12] = t3;
    $[13] = tab;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== active.isPending || $[16] !== mine || $[17] !== pending || $[18] !== tab) {
    t6 = active.isPending ? <div className="flex flex-col gap-2.5">{[0, 1, 2].map(_temp4)}</div> : tab === "pending" ? (pending.data ?? []).length === 0 ? <CabinetEmpty title={"\u0412\u0441\u0435 \u043E\u0442\u0437\u044B\u0432\u044B \u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u044B"} hint={"\u041A\u043E\u0433\u0434\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u0437\u0430\u043A\u0430\u0437, \u0442\u043E\u0432\u0430\u0440\u044B \u043F\u043E\u044F\u0432\u044F\u0442\u0441\u044F \u0437\u0434\u0435\u0441\u044C."} /> : <div className="flex flex-col gap-2.5">{(pending.data ?? []).map(item => <PendingReviewCard key={`${item.orderId}-${item.productId}`} item={item} onRate={stars => setRating({
        item,
        stars
      })} />)}</div> : (mine.data ?? []).length === 0 ? <CabinetEmpty title={"\u041E\u0442\u0437\u044B\u0432\u043E\u0432 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442"} hint={"\u041E\u0446\u0435\u043D\u0438\u0442\u0435 \u043A\u0443\u043F\u043B\u0435\u043D\u043D\u044B\u0435 \u0442\u043E\u0432\u0430\u0440\u044B \u0432\u043E \u0432\u043A\u043B\u0430\u0434\u043A\u0435 \xAB\u0416\u0434\u0443\u0442 \u043E\u0442\u0437\u044B\u0432\u0430\xBB."} /> : <div className="flex flex-col gap-4">{(mine.data ?? []).map(_temp5)}</div>;
    $[15] = active.isPending;
    $[16] = mine;
    $[17] = pending;
    $[18] = tab;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== rating || $[21] !== submit) {
    t7 = rating ? <LeaveReviewModal key={`${rating.item.orderId}-${rating.item.productId}`} open={true} onOpenChange={o => {
      if (!o) {
        setRating(null);
      }
    }} subject={{
      photo: rating.item.image ?? undefined,
      title: rating.item.name,
      subtitle: rating.item.brand,
      variant: rating.item.variant ?? undefined
    }} onSubmit={submit} initialRating={rating.stars} onUploadMedia={_temp6} /> : null;
    $[20] = rating;
    $[21] = submit;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t5 || $[24] !== t6 || $[25] !== t7) {
    t8 = <ProfilePanel title={"\u041E\u0442\u0437\u044B\u0432\u044B"}>{t5}{t6}{t7}</ProfilePanel>;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
}
function _temp6(file) {
  return api.cabinet.uploadReviewMedia(file);
}
function _temp5(review) {
  return <MyReviewCard key={review.id} review={review} />;
}
function _temp4(i) {
  return <Skeleton key={i} className="h-[149px] rounded-[20px]" />;
}
function _temp3() {
  return api.cabinet.reviews();
}
function _temp2() {
  return api.cabinet.pendingReviews();
}
function _temp(s) {
  return s.user?.id ?? "guest";
}